module.exports = __webpack_public_path__ + "static/media/6.af18fbd7.jpg";